var lightbox = require("lightbox2");

lightbox.option({
  'showImageNumberLabel': false,
  'disableScrolling': true
});

angular
 .module("app.directives")
 .directive('lightboxInit', function($timeout){
   return {
     restrict: 'A',
     link: function(scope, element, attrs) {
       $timeout(function(){
         lightbox.init();
       }, 1)
     }
   }
 })
